import { logBuildStamp } from "./common/buildStampLog";
import  { createApp } from "vue";
import Axios from 'axios'
import UIKit from 'uikit/dist/js/uikit.min'
import UIKitIcons from 'uikit/dist/js/uikit-icons.min'
import BaseLayout from 'components/layouts/BaseLayout.vue'
import {
    AjaxIsLoadingLogisticsMixin,
    TestStateMixin,
    ThemeMixin,
    IsDemoMixin,
    IsLoggedInMixin,
} from 'Mixins'
import {
    resetDefaultStore,
    setCurrentStorageUser,
} from 'common/localStorage/currentStorageUser'
import { TestData, TestState, Professions, Subscription } from 'Models'
import { createRouter, createWebHashHistory } from "vue-router";
import { createPinia } from 'pinia'
import store from "./vuex/store";

const pinia = createPinia()
const AuthFallback = { render: () => null }

const router = createRouter({
    mode: "hash",
    routes: [{ path: '/:pathMatch(.*)*', name: 'auth-fallback', component: AuthFallback }],
    history: createWebHashHistory(),
  });

window.axios = Axios
window.uikit = UIKit

window.uikit.use(UIKitIcons)


window.$_http = window.axios
window.$_store = store

window.axios.defaults.headers.common = { 'X-Requested-With': 'XMLHttpRequest' }

const app = createApp({

    components: { 'base-layout': BaseLayout },
    store: store,

    data() {
        return { userEmail: '' }
    },

    watch: {
        userEmail(to, from) {
            setCurrentStorageUser(to)
        },
    },

    created() {
        localStorage.clear()
        setCurrentStorageUser('')
        sessionStorage.removeItem('shopAuth')
    },

    mounted() {
        const hash = (window.location.hash || '').toLowerCase()
        if (hash.startsWith('#/chat')) {
            window.location.replace('/chat/public#/chat/readonly')
            return
        }

        let email = $('#email')
        setTimeout(() => email.focus(), 250)

        $('#loginView').removeClass('hidden')
        $('#preloader').addClass('hidden')

        if (!this.isLoginForInstitutionAttendees())
            $('#password-forgotten-link').removeClass('hidden')
    },

    methods: {
        isLoginForInstitutionAttendees() {
            return (
                window.location.href.endsWith('/plus') ||
                window.location.href.endsWith('/plus/') ||
                window.location.href.endsWith('/plus/login')
            )
        },
    },
})

app.config.globalProperties.$http =  window.axios
app.config.globalProperties.log = (x) => {
    console.log(x)
    return x
}

app.use(pinia)
app.use(router);

app.mixin(AjaxIsLoadingLogisticsMixin)
app.mixin(TestStateMixin)
app.mixin(ThemeMixin)
app.mixin(IsDemoMixin)
app.mixin(IsLoggedInMixin)

window.Vue = app
logBuildStamp("eTrainer Auth");
app.mount('#app');